import { render, staticRenderFns } from "./DidiVerifyForm.vue?vue&type=template&id=12c3e6f4&scoped=true&"
import script from "./DidiVerifyForm.vue?vue&type=script&lang=js&"
export * from "./DidiVerifyForm.vue?vue&type=script&lang=js&"
import style0 from "./DidiVerifyForm.vue?vue&type=style&index=0&id=12c3e6f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3e6f4",
  null
  
)

export default component.exports